export const sxStyles = {
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  flexWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  checkbox: {
    display: 'flex',
    alignItems: 'start',

    '& > span:first-of-type': {
      paddingTop: 0,
    },
  },
};
